const OrdenaConvidados = (convidados) => {
  convidados.sort((a, b) => {
    const nomeA = (a.usuario ? a.usuario.nome : a.grupo.nome) + " " + a.papel.nome;
    const nomeB = (b.usuario ? b.usuario.nome : b.grupo.nome) + " " + b.papel.nome;
    return (nomeA < nomeB) ? -1 : ((nomeA > nomeB) ? 1 : 0);
  });
  return convidados;
};
export default OrdenaConvidados;
